import TagManager from "react-gtm-module";
import { hotjar } from "react-hotjar";
import Environment from "./Environment";

export default class Analytics {
  //Tracks prod and dev (test stream) only

  static HOTJAR_ID = 2984320;
  static HOTJAR_ID_TEST = 2984320;
  static HOTJAR_VERSION = 6;

  static GA_ID = "G-X4RZEX6QXR";
  static GA_ID_TEST = "G-WDV68Y8EHD";

  static GTM_ID = "GTM-PR3JZT3";

  static initialize() {
    //if (Environment.isLocal) return Analytics.skipAnalytics();

    //GA
    /*ReactGA.initialize(Environment.isProduction ? this.GA_ID : this.GA_ID_TEST, {
            debug: Environment.isTest,
            titleCase: true
        });*/

    //Hot jar
    hotjar.initialize(
      Environment.isProduction ? this.HOTJAR_ID : this.HOTJAR_ID_TEST,
      this.HOTJAR_VERSION
    );
  }

  static identify(user: any, organization: any) {
    //if (Environment.isLocal) return Analytics.skipAnalytics();

    //GA
    //ReactGA.set({ userId: user.employeeId });
    //ReactGA.set({ 'user_properties': this.getProperties(user, organization) });

    //GTM
    TagManager.initialize({
      gtmId: this.GTM_ID,
      dataLayer: this.getProperties(user, organization),
      preview: Environment.isProduction ? undefined : "env-3",
    });

    //Hot jar
    hotjar.identify(user.employeeId, this.getProperties(user, organization));
  }

  static getProperties(user: any, organization: any) {
    let properties: any = {
      orgId: organization.organizationId,
      orgName: organization.name,
      orgTrial: organization.isTrial,
      orgStatus: organization.status.label,
      orgIsDemo: organization.isDemo,
      userId: user.loggedInUserEmployeeId,
      userFirstName: user.loggedInUserFirstName,
      userHasJob: user.loggedInUserHasJob,
      userJobTitle: user.loggedInUserJobTitle,
      userIsAdmin: user.loggedInUserIsOrganizationAdmin,
      userIsBillingAdmin: user.loggedInUserIsBillingUser,
      userIsManager: user.loggedInUserIsTeamLead,
    };

    if (user.impersonating)
      properties = {
        ...properties,
        /*impersonatedOrgId: organization.organizationId,
            impersonatedOrgName: organization.name,
            impersonatedOrgTrial: organization.isTrial,
            impersonatedOrgStatus: organization.status.label,
            impersonatedOrgIsDemo: organization.isDemo,*/
        impersonatedUserId: user.employeeId,
        impersonatedUserFirstName: user.firstName,
        impersonatedUserHasJob: user.hasJob,
        impersonatedUserJobTitle: user.jobTitle,
        impersonatedUserIsAdmin: user.isOrganizationAdmin,
        impersonatedUserIsBillingAdmin: user.isBillingUser,
        impersonatedUserIsManager: user.isTeamLead,
      };

    return properties;
  }

  static event(action: any, params: any) {
    //if (Environment.isLocal) return Analytics.skipAnalytics();

    //Hot jar
    hotjar.event(action);

    //GA
    //ReactGA.event({ category, action });

    //GTM
    TagManager.initialize({
      gtmId: this.GTM_ID,
      events: {
        [action]: params,
      },
    });
  }

  static skipAnalytics() {}
}
